import {
  call, put, takeLatest, select,
} from 'redux-saga/effects';

import {
  GET_CLIENTES_REQUEST,
} from '../../actions/constants/clientes/clientes.constants';
import { authRequest } from '../../../helpers/request.helper';
import {
  getClientesFailureAction,
  getClientesSuccessAction,
} from '../../actions/creators/clientes/clientes.actioncreator';

const getClientesFromState = state => state.clientes;

function* getClientes(action) {
  const { payload } = action;
  const {
    page, start, limit, sede, archivado, tipoListado, busqueda, clientesSeleccionados,
  } = payload;
  debugger;
  let url = `Clientes.clientes/?page=${page}&start=${start}&limit=${limit}&sede_seleccionada=${sede}&archivado=${archivado}&tipo_listado=${tipoListado}`;

  const filtros = [];
  const hayBusqueda = busqueda !== null && busqueda !== '';
  if (hayBusqueda) {
    filtros.push({
      property: 'busqueda', value: busqueda, operator: 'like',
    });
  }
  if (clientesSeleccionados.length > 0) {
    filtros.push({
      property: 'clientes_seleccionados', value: clientesSeleccionados, operator: 'in',
    });
  }

  const queryString = encodeURIComponent(JSON.stringify(filtros));
  url += `&filter=${queryString}`;

  const params = {
    url,
    method: 'GET',
  };

  try {
    const response = yield call(authRequest, params);
    const { datos, success, total } = response;
    if (success) {
      const clientesFromState = yield select(getClientesFromState);

      yield put(getClientesSuccessAction(datos, total, page, start, limit));
    } else {
      yield put(getClientesFailureAction());
    }
  } catch (error) {
    yield put(getClientesFailureAction(error));
  }
}

export function* getClientesRequest() {
  yield takeLatest(GET_CLIENTES_REQUEST, getClientes);
}
